import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "../lib/axios";

const ORGANIZATION_SELF_ROUTE = "/organizations/self";

interface OrganizationSelfResponse {
  organization: {
    id: number;
    name: string;
    domain: string;
    role: string;
  };
}

export const useOrganizationSelf = (enabled = true) => {
  return useQuery({
    queryKey: ["organization-self"],
    queryFn: async () => {
      const response = await axiosInstance.get<OrganizationSelfResponse>(
        ORGANIZATION_SELF_ROUTE,
      );
      return response.data.organization;
    },
    enabled,
  });
};
